import React from 'react';
import { Container, Box, Button } from "@mui/material";
import BaseTypography from '../../Utilities/BaseTypography';

export default function Banner({ scrollToForm, navigate }) {
  const handleGoBack = () => {
    navigate('/article');
  };

  return (
    <Container maxWidth={false}
      sx={{
        backgroundImage: `url('/images/bannerBg.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minHeight: '750px',
        paddingTop: '80px',
        paddingBottom: '15px',
        position: 'relative',
      }}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}>

        <Box sx={{
          display: 'flex',
          alignItems: 'flex-start',
          pb: 8,
          ml: { xs: 0, md: 0 }
        }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              borderRadius: '6px',
              p: '4px 8px',
              minWidth: 'fit-content',
              width: 'fit-content',
              transition: 'background-color 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              },
              gap: '8px'
            }}
            onClick={handleGoBack}
          >
            <img
              src="/images/leftArrow.png"
              alt="Back"
              style={{ width: 24, height: 24 }}
            />
            <BaseTypography
              type='label'
              sx={{
                fontStyle: 'normal',
                color: '#000000',
                fontWeight: 400,
                userSelect: 'none'
              }}
            >
              Go back
            </BaseTypography>
          </Box>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          my: 4
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: '10px'
            }}>
              <img
                src="/images/eatchIcon.svg"
                alt="NC Pro"
                style={{ maxWidth: "100%", height: "auto", paddingRight: '10px' }}
              />
              <BaseTypography type='label' sx={{ fontWeight: 400, color: '#0E3EBA' }}>
                Non-Conformity Pro
              </BaseTypography>
            </div>
            <div style={{
              paddingBottom: '15px'
            }}>
              <BaseTypography type='heading' sx={{ fontSize: '34px', textAlign: 'center' }}>
                <span style={{
                  background: 'linear-gradient(270.29deg, #43B0D7 73.9%, #0D2663 99.75%)',
                  color: 'transparent',
                  backgroundClip: 'text'
                }}>Quality</span> control & management
              </BaseTypography>
            </div>
            <div style={{ paddingBottom: '8px' }}>
              <BaseTypography
                sx={{
                  textAlign: 'center',
                  letterSpacing: '0.4px',
                  width: {
                    md: '60%',
                    xs: '90%'
                  },
                  color: '#262626',
                  margin: '0 auto'
                }}
              >
                GB NC pro is a software tool that captures and analyses engineering quality issues, ensuring compliance and preventing future problems through detailed documentation and analysis
              </BaseTypography>
            </div>
            <div>
              <Button
                variant="outlined"
                sx={{
                  fontFamily: 'Lato, sans-serif',
                  borderRadius: '20px',
                  border: '1px solid transparent',
                  backgroundImage: 'linear-gradient(white, white), linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  py: 1,
                  my: 3,
                  color: '#0D2663',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: '700',
                  lineHeight: '16.8px'
                }}
                endIcon={<img src="/images/sendIcon.svg" alt="icon" style={{ width: 20, height: 20 }} />}
                onClick={scrollToForm}
              >
                Request enquiry
              </Button>
            </div>
          </div>
        </Box>
      </Container>
    </Container>
  )
}